'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Experiments = function () {
  function Experiments() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, Experiments);

    this.experiments = obj.experiments || {};
    this.loaders = [];
    if (obj.scope) {
      this.load(obj.scope);
    }
  }

  (0, _createClass3.default)(Experiments, [{
    key: 'add',
    value: function add(obj) {
      this.experiments = (0, _extends3.default)({}, this.experiments, obj);
    }
  }, {
    key: 'get',
    value: function get(key) {
      return this.experiments[key];
    }
  }, {
    key: 'enabled',
    value: function enabled(key) {
      return this.get(key) === 'true';
    }
  }, {
    key: 'all',
    value: function all() {
      return this.experiments;
    }
  }, {
    key: '_loading',
    value: function _loading(promise) {
      var _this = this;

      this.loaders.push(promise);
      promise.then(function () {
        _this.loaders = _this.loaders.filter(function (x) {
          return x !== promise;
        });
      });
      return promise;
    }
  }, {
    key: '_getUrlWithFallback',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(url, fallback) {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _axios2.default.get(url);

              case 3:
                response = _context.sent;
                return _context.abrupt('return', response.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return', fallback);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function _getUrlWithFallback(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return _getUrlWithFallback;
    }()
  }, {
    key: 'load',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(scope) {
        var url, obj;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = '/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=' + scope;
                _context2.next = 3;
                return this._loading(this._getUrlWithFallback(url, {}));

              case 3:
                obj = _context2.sent;

                this.add(obj);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load(_x4) {
        return _ref2.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: 'conduct',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(spec, fallback) {
        var url, value;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = '/_api/wix-laboratory-server/laboratory/conductExperiment?key=' + spec + '&fallback=' + fallback;
                _context3.next = 3;
                return this._loading(this._getUrlWithFallback(url, fallback));

              case 3:
                value = _context3.sent;

                this.add((0, _defineProperty3.default)({}, spec, value));
                return _context3.abrupt('return', value);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function conduct(_x5, _x6) {
        return _ref3.apply(this, arguments);
      }

      return conduct;
    }()
  }, {
    key: 'pending',
    value: function pending() {
      return !!this.loaders.length;
    }
  }, {
    key: 'ready',
    value: function ready() {
      return _promise2.default.all(this.loaders);
    }
  }]);
  return Experiments;
}();

exports.default = Experiments;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-experiments/dist/src/index.js
// module id = 863
// module chunks = 0